__turbopack_context__.v({
  "preview": "index-module-scss-module__-Z3jHW__preview",
  "show_review_button": "index-module-scss-module__-Z3jHW__show_review_button",
  "wrapper": "index-module-scss-module__-Z3jHW__wrapper",
});
